import type { ConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ProgramEventSlimDataObject, ProgramListEventDataObject } from 'models/service';

export type EventsRequest = paths['/v3/events']['get']['parameters']['query'];

// TODO: fix type once `useEventsInfiniteQuery` response types are unified
export const getEvents = async <T extends ProgramEventSlimDataObject[] | ProgramListEventDataObject[]>({
  config,
}: ConfigRequest<EventsRequest>) => apiClient.get<T, ApiClientResponse<T>>(routes.events.find, config);
